<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="sampleSetTestForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                sampleSetTestForm: () => import('../forms/SampleSetTestForm'),
                headers: [
                    { text: 'Sample Set', value: 'sampleSetId', table: 'sampleSets', form: () => import('../forms/SampleSetForm') },
                    { text: 'Lab Test', value: 'labTestId', table: 'labTests', form: () => import('../forms/LabTestForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    labTests: [],
                    sampleSets: [],
                    items: []
                },
                sorting: [
                    { column: "sampleSetId", direction: "ascending" },
                    { column: "labTestId", direction: "ascending" },
                ],
                itemsField: 'sampleSetTests',
                editPageName: 'sampleSetTest',
                apiMethod: 'SampleSetTests',
                claimName: 'SampleSetTests',
                formTitle: 'Sample Set Test',
                excelTitle: 'Sample Set Tests',
                hasEditPage: false,
            }
        },
    };
</script>
